import * as React from "react";
/**
 * PlannerTheme context
 */ export const PlannerThemeContext = React.createContext(undefined);
/** PlannerTheme Context Provider */ export const PlannerThemeContextProvider = PlannerThemeContext.Provider;
